export default "__VITE_ASSET__DmiBwyot__"